// Подпись наложенного отбора словами: «отбор: Барк, Шатун Андрей».
//
// Нужна на БУМАГЕ. Шапка с отборами на печать не идёт (она не документ), и итог «Выдано за май 2026»
// без этой строки читался бы как итог месяца целиком, хотя отобрано одно юрлицо или один человек.
// На экране та же строка тоже не лишняя: отборы видны в шапке, но подпись под числом отвечает на
// «чьё это число» там, где человек на него смотрит.

/** Подпись или `undefined`, когда отборов нет. Пока справочник едет, имени нет и часть пропускается. */
export function подписьОтбора(части: readonly (string | undefined)[]): string | undefined {
  const есть = части.filter((часть): часть is string => часть !== undefined && часть !== '');
  return есть.length === 0 ? undefined : `отбор: ${есть.join(', ')}`;
}
